import { People, Info } from "@mui/icons-material"
import { DataRow } from "./DataField"
import IconTitle from "./IconTitle"
import { Grid2 as Grid, Box } from "@mui/material"
import { Persona } from "../types"
import { useTranslation } from "react-i18next"

type WithChiavi = {
  persone_data?: Persona[]
  luoghi_data?: any[]
  enti_data?: any[]
  tags_data?: any[]
}

export default function ChiaviAccessoDisplay<T extends WithChiavi>({ item }: { item: T|null|undefined }) {
  const { t } = useTranslation()
  
  return (
    <>
      <DataRow>
        <Grid size={12}>
          <IconTitle icon={<People />} title={t("general.persone")} />
        </Grid>
        <Grid size={12}>
          {item?.persone_data?.map((persona: Persona) => (
            <Box key={persona.id}>{persona.nome}</Box>
          ))}
        </Grid>
      </DataRow>

      <DataRow>
        <Grid size={12}>
          <IconTitle icon={<Info />} title={t("general.luoghi")} />
        </Grid>
        <Grid size={12}>
          {item?.luoghi_data?.map((luogo) => (
            <Box key={luogo.id}>{luogo.nome}</Box>
          ))}
        </Grid>
      </DataRow>

      <DataRow>
        <Grid size={12}>
          <IconTitle icon={<Info />} title={t("general.enti")} />
        </Grid>
        <Grid size={12}>
          {item?.enti_data?.map((ente) => (
            <Box key={ente.id}>{ente.nome}</Box>
          ))}
        </Grid>
      </DataRow>

      <DataRow last>
        <Grid size={12}>
          <IconTitle icon={<Info />} title={t("general.temi")} />
        </Grid>
        <Grid size={12}>
          {item?.tags_data?.map((tag) => (
            <Box key={tag.id}>{tag.nome}</Box>
          ))}
        </Grid>
      </DataRow>
    </>
  )
}
